import Game from './Game';
import { LocationNode } from './graph';
import NatsObject from './lib/NatsObject';
import StClient from './StClient';

export type LocationData = {
	id: string;
	customer_id: string;
	name: string;
	time_zone: string;
	extra?: any;
};

export class Location extends NatsObject<LocationData> {
	data: LocationNode;
	game?: Game;

	constructor(client: StClient, data: LocationNode) {
		super(client, data.id);
		this.data = data;

		if (data.games.nodes.length) {
			this.game = new Game(client, data.games.nodes[0], this);
		}
	}
}

export { Location as default };
